import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loadingInterface',
  templateUrl: './loading-interface.component.html',
  styleUrls: ['./loading-interface.component.sass']
})
export class LoadingInterfaceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
